/* eslint-disable import/no-unresolved */

import { createVueApp } from '@vuejs/entry';

/*
Formularz przedsprzedazy SAVICKI x Doda. Dane (produkty, formy platnosci, salony)
renderuje Twig do #doda-presale-data, a apka Vue dostaje je przez provide.
*/
const readPresaleData = () => {
    const el = document.getElementById('doda-presale-data');

    if (!el) {
        return null;
    }

    try {
        return JSON.parse(el.textContent);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[doda-presale] Niepoprawny JSON w #doda-presale-data', err);

        return null;
    }
};

document.addEventListener('DOMContentLoaded', async () => {
    const mount = document.getElementById('doda-presale-app');
    const data = readPresaleData();

    if (!mount || !data) {
        return;
    }

    const { default: DodaPresaleApp } = await import(
        /* webpackChunkName: "DodaPresaleApp" */ '@vuejs/apps/landing/DodaPresaleApp.vue'
    );

    createVueApp(DodaPresaleApp, { globalState: { presaleData: data } }).mount(mount);
});
